import React from 'react';

export default function StorefrontIcon({
    size = 18,
    color = '#008C8C',
    strokeWidth = 1.5,
    ...props
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M3.06204 8.38338V11.2936C3.06204 14.2037 4.22871 15.3704 7.13889 15.3704H10.6324C13.5426 15.3704 14.7093 14.2037 14.7093 11.2936V8.38338M10.8333 6.7371L10.4055 2.40747H7.37869L6.94443 6.7371C6.82777 7.92321 7.70277 8.88895 8.88888 8.88895C10.075 8.88895 10.95 7.92321 10.8333 6.7371ZM15.1176 6.52321L14.9361 4.7408C14.7028 3.05562 14.0546 2.40747 12.3565 2.40747H10.3796L10.8333 6.95099C10.9435 8.02043 11.9092 8.88895 12.9787 8.88895C14.288 8.88895 15.2472 7.82599 15.1176 6.52321ZM6.90556 6.95099C6.80185 8.02043 5.83611 8.88895 4.76667 8.88895C3.45741 8.88895 2.49815 7.82599 2.62778 6.52321L2.80278 4.7408C3.03611 3.05562 3.68426 2.40747 5.38241 2.40747H7.35926L6.90556 6.95099ZM7.26852 13.7501V15.3704H10.5093V13.7501C10.5093 12.6677 9.97129 12.1297 8.88889 12.1297C7.80648 12.1297 7.26852 12.6677 7.26852 13.7501Z"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}